import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, delay, exhaustMap } from 'rxjs';
import { mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';
import { emailReportRuleActions } from './email-report-rule.actions';
import { EmailReportRuleService } from '../../../api/services';

export const emailReportRuleFindEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.find),
      concatMap((props) =>
        service.emailReportRuleControllerFind(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailReportRuleActions.findDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              emailReportRuleActions.findDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailReportRuleFindOneEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.findOne),
      exhaustMap((props) =>
        service.emailReportRuleControllerFindOne(props).pipe(
          delay(500),
          mapResponse({
            next: (r) => emailReportRuleActions.findOneDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              emailReportRuleActions.findOneDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailReportRuleCreateEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.create),
      concatMap((props) =>
        service.emailReportRuleControllerCreate(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailReportRuleActions.createDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              emailReportRuleActions.createDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailReportRuleUpdateEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.update),
      concatMap((props) =>
        service.emailReportRuleControllerUpdate(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailReportRuleActions.updateDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              emailReportRuleActions.updateDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailReportRuleDeleteEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.deleteRule),
      exhaustMap((props) =>
        service.emailReportRuleControllerDelete(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailReportRuleActions.deleteRuleDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              emailReportRuleActions.deleteRuleDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailReportRuleSendNowEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailReportRuleService)) =>
    actions$.pipe(
      ofType(emailReportRuleActions.sendNow),
      exhaustMap((props) =>
        service.emailReportRuleControllerSendNow(props).pipe(
          delay(500),
          mapResponse({
            next: () => emailReportRuleActions.sendNowDone({ state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              emailReportRuleActions.sendNowDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);
